(function () {
	'use strict';
	angular.module('app.core')
		.service('buyerPerformanceRenderService', buyerPerformanceRenderService)
		.config(function ($uibTooltipProvider) {
			$uibTooltipProvider.options({
				'popupDelay': '100',
				'placement': 'auto top'
			});
		});

	buyerPerformanceRenderService.$inject = ['$filter', '$sce', '$experiments', '$translate', 'currencyFormatService', 'integerFormatService', 
		'leanFilterService', 'numberFormatService', 'URLS', 'shortageCriticalityLevelService', 'drilldownFunctionsService', 'siteService'];

	function buyerPerformanceRenderService($filter, $sce, $experiments, $translate, currencyFormatService, integerFormatService, 
			leanFilterService, numberFormatService, URLS, shortageCriticalityLevelService, drilldownFunctionsService, siteService) {
		var buyerPerfDrilldown = URLS.frontendPrefix + 'dashboard/byType?drilldown=1';
		var buyerPerfDashboard = URLS.frontendPrefix + 'supply-chain/buyer-performance/';
		var burnOffDrilldownUrl = URLS.frontendPrefix + 'supply-chain/inventory-burnoff/?drilldown=1';
		var openDrilldownUrl = URLS.frontendPrefix + 'supply-chain/inventory-actions/?drilldown=1&inventoryActionStatus=isOpen,isSnoozed';
		var fixedOrExpiredDrilldownUrl = URLS.frontendPrefix + 'supply-chain/inventory-actions/?drilldown=1&inventoryActionStatus=';
		var purchaseRequisitionsUrl = URLS.frontendPrefix + 'supply-chain/purchase-requisitions/';
		var excessToSellDrilldown = URLS.frontendPrefix + 'supply-chain/excess-to-sell/?drilldown=1';
		var weeklyChangeUrl = URLS.frontendPrefix + 'supply-chain/inventory-opportunities/weekly-inventory-change/?drilldown=1';
		var excessObsoleteInventoryUrl = URLS.frontendPrefix + 'supply-chain/inventory-opportunities/excess-and-obsolete-inventory/?drilldown=1';
		var activeItemsUrl = URLS.frontendPrefix + 'supply-chain/inventory-opportunities/pfep-all-items/?drilldown=1';
		var buyerMappingConfigurationUrl = 'site-setup/buyer-mapping-configuration';

		var service = {
			currentShortages: currentShortages,
			currentShortagesBreakdown: currentShortagesBreakdown,
			burnOffTarget: burnOffTarget,
			activeItems: activeItems,
			currencyWithPfepDrilldown: currencyWithPfepDrilldown,
			openInventoryActions: openInventoryActions,
			fixedOrExpiredInventoryActions: fixedOrExpiredInventoryActions,
			onHandInventoryDelta: onHandInventoryDelta,
			excessInventoryDelta: excessInventoryDelta,
			shortagesDelta: shortagesDelta,
			latePRCount: latePRCount,
			daysSinceLastAccess: daysSinceLastAccess,
			site: site,
			itemGroup: itemGroup,
			excessToSell: excessToSell,
			calculateDeltaValues: calculateDeltaValues,
			aggregateDataForBuyerWithNoItem: aggregateDataForBuyerWithNoItem,
			buyerRenderer: buyerRenderer,
			buyerMappingIssueRenderer: buyerMappingIssueRenderer,
			getFilterTooltip: getFilterTooltip,
			buildOrderedLevelList: buildOrderedLevelList,
			countSummaryRenderer: countSummaryRenderer
		};

		return service;

		function countSummaryRenderer(row, col, rowIndex, params) {
			var loginCount = row[col.id];
			if (loginCount == null) return '<div class="cell-div"></div>';
			var countSummary;
			switch (col.id) {
			case 'loginCount30Days':
				countSummary = row.loginCountSummary;
				break;
			case 'daysIAEngaged':
				countSummary = row.daysIAEngagedSummary;
				break;
			case 'daysEngaged':
				countSummary = row.daysEngagedSummary;
				break;
			default:
				break;
			}
			
			if (countSummary == null) {
				return '<div class="cell-div">' + loginCount + '</div>';
			}
			var tooltip = summaryTooltip(countSummary, 'count');
			var tooltipAttributes = ' tooltip-class="white-tooltip no-padding" uib-tooltip-html="\'' + tooltip + '\'" ';
			return '<div class="cell-div ' + getFooterClass(params, rowIndex) + '"' + tooltipAttributes + '>' + loginCount + '</div>';
		}

		function appendAssignedToUserToBuyerCode(row, buyerCode) {
			var buyerAssignedUserNames = row['buyerAssignedUserNames'];
			var siteCount = 0;
			var assignedAtSiteCount = 0;
			var uniqueUserNames = new Set();
			for (var site in buyerAssignedUserNames) {
				siteCount += 1;
				uniqueUserNames.add(buyerAssignedUserNames[site]);
				if (buyerAssignedUserNames[site] != null) {
					// buyerCode mapped to an actual username
					assignedAtSiteCount += 1;
				}
			}
			if (uniqueUserNames.size > 1) {
				if (assignedAtSiteCount != siteCount) {
					// more than 1 unique username, not mapped in all sites
					return ' (' + $translate.instant('Assigned to user at {{assignedAtSiteCount}} of {{siteCount}} sites', {assignedAtSiteCount: assignedAtSiteCount, siteCount: siteCount}) + ')';
				}
			} else if (uniqueUserNames.size == 1) {
				var iterator = uniqueUserNames.values();
				var buyerAssignedUserName = iterator.next().value;
				if (buyerAssignedUserName != null && buyerAssignedUserName.toLowerCase() != buyerCode.toLowerCase()) {
					// 1 unique username, doesn't match buyerCode
					return ' (' + $translate.instant('Assigned to {{buyerAssignedUserName}}', {buyerAssignedUserName: buyerAssignedUserName}) + ')';
				}
			}
			// 0 unique name, or 1 unique name that matches buyerCode
			return '';
		}

		function getBuyerMappingConfigurationUrl(params) {
			return getReactDrilldownUrl(buyerMappingConfigurationUrl, params);
		}

		function setDrilldownUrlToBuyerCode(row, buyerCode) {
			var buyerAssignedUserNames = row['buyerAssignedUserNames'];
			var drilldownParams = {};
			drilldownParams.buyerCode = buyerCode;
			for (var site in buyerAssignedUserNames) {
				if (siteService.isAdminForSite(site) && buyerAssignedUserNames[site] == null && buyerCode != 'UndefinedBuyer') {
					drilldownParams.adminFactory = site;
					return '<a href="' + getBuyerMappingConfigurationUrl(drilldownParams) + '" target="_blank">' + buyerCode + '</a>';
				}
			}
			return buyerCode;
		}

		function buyerRenderer(row, col, rowIndex, params) {
			var cellValue = row[col.id];
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var rawHtml = '<div class="cell-div">';
			if (isAggregated) {
				var aggregatedBuyers = row['aggregatedBuyers'];
				var url = buyerPerfDashboard + params['dashboardId'] + '?showAll=1';
				rawHtml += '<a href="' + url + '" title="' + aggregatedBuyers + '">' + cellValue + ' (' + row['buyerCount'] + ')</a>';
			} else {
				cellValue = setDrilldownUrlToBuyerCode(row, cellValue);
				cellValue += appendAssignedToUserToBuyerCode(row, cellValue);
				rawHtml += cellValue;
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function buyerMappingIssueRenderer(row, col, rowIndex, params) {
			var isSingleSiteView = leanFilterService.getFactoryList(true).length == 1;
			var value = row[col.id];
			var statusSummary = row.buyerMappingIssueSummary;
			var displayValue = '';

			if (statusSummary == null) {
				return '<div class="cell-div">' + displayValue + '</div>';
			}
			
			var siteCount = Object.keys(statusSummary).length;
			var filteredSummary = Object.fromEntries(Object.entries(statusSummary).filter(function(entry) { return entry[1] != null; }));
			var  issueCount = Object.keys(filteredSummary).length;
			if (siteCount > 1 && issueCount > 0) {
				displayValue = $translate.instant('Issues ({{x}} of {{y}} sites)', {x: issueCount, y: siteCount});
			} else {
				displayValue = buyerMappingIssueSelector(value);
			}

			var terms = {
				'NoAccount': $translate.instant('We cannot find an account in LeanDNA that matches the buyer code {{buyerCode}}. In order to match the buyer code, the concatenated first and last name in the account must be identical to the buyer code.', {buyerCode: row['buyer']}),
				'UnreachableEmail': $translate.instant('The account that is associated with this buyer code has an email address that is not receiving emails. This may indicate that the email address was configured incorrectly, has recently changed, or that the person is no longer with the organization. Please check this email address and correct it, or reassign the items to a different buyer.'),
				'NonBuyer': $translate.instant('This buyer has less than 1% (or less than 300k) of the total on order for the site. LeanDNA will not consider this buyer code when determining the percentage of engaged buyers in places like the Site Performance report.')
			};

			var tooltipAttributes = '';
			if (issueCount > 0) {
				if (isSingleSiteView) {
					var tooltip = terms[value];
					tooltipAttributes = ' tooltip-class="white-tooltip issue-definition" uib-tooltip-html="\'' + tooltip + '\'" ';
				} else {
					var tooltip = buyerMappingIssueSummaryTooltip(filteredSummary, terms);
					tooltipAttributes = ' tooltip-class="white-tooltip no-padding" uib-tooltip-html="\'' + tooltip + '\'" ';
				}
			}
			return '<div class="cell-div ' + getFooterClass(params, rowIndex) + '"' + tooltipAttributes + '>' + displayValue + '</div>';
		}

		function buyerMappingIssueSelector(value) {
			switch (value) {
			case 'NoAccount':
				return $translate.instant('No account linked');
			case 'UnreachableEmail':
				return $translate.instant('Unreachable email address');
			case 'NonBuyer':
				return $translate.instant('Non-buyer');
			default:
				return '';
			}
		}

		function buyerMappingIssueSummaryTooltip(summary, terms) {
			var tooltip = '<div class="myTooltip performance-tooltip">' +
				'<div class="tooltipIssueBody">' +
				'<table border="1px solid">';
			tooltip += '<tr>' + '<th><span>' + $translate.instant('Site') + '</span></th>'
				+ '<th><span>' + $translate.instant('Issue') + '</span></th></tr>';
			var needDefinition = [];
			Object.entries(summary).forEach(function(obj) {
				var site = obj[0];
				var val = obj[1];
				var value = buyerMappingIssueSelector(val);
				if (!needDefinition.includes(val)) {
					needDefinition.push(val);
				}
				var index = needDefinition.indexOf(val);
				tooltip += '<tr>' + '<td><span>' + site + '</span></td>'
					+ '<td><span>' + value + ' ' + '*'.repeat(index + 1) + '</span></td></tr>';
			});
			tooltip += '</table>';
			tooltip += '<div class="legendContainer">';
			var i = 1;
			needDefinition.forEach(function(issue) {
				var definition = terms[issue];
				tooltip += '<div class="tooltipIssueLegend"><b>' + ('*'.repeat(i)) + '</b> ' + definition + '</div>';
				i++;
			});
			tooltip += '</div></div>';
			return tooltip.replace(/\"/g, '&quot;');
		}

		function summaryTooltip(summary) {
			var tooltip = '<div class="myTooltip performance-tooltip">' +
				'<div class="tooltipBody">' +
				'<table border="1px solid">';
			Object.entries(summary).forEach(function(obj) {
				var site = obj[0];
				var value = obj[1] || 0;
				tooltip += '<tr>' + '<td><span>' + site + '</span></td>'
					+ '<td><span>' + value + '</span></td></tr>';
			});
			tooltip += '</table></div></div>';
			return tooltip.replace(/\"/g, '&quot;');
		}

		function getFooterClass(params, rowIndex) {
			var classString = '';
			if (params.lastIndex && rowIndex == params.lastIndex) {
				classString = 'footer ';
			}
			return classString = '';
		}

		function getShortagesUrl(col, comparableColumnId, drilldownParams) {
			if (col.id === comparableColumnId) {
				return getReactShortageByItemUrl(drilldownParams);
			}

			return getReactShortageByOrderUrl(drilldownParams);
		}

		function getReactShortageByItemUrl(drilldownParams) {
			drilldownParams.daysInShortage = {
				filterType: 'rangeFilter',
				comparator: leanFilterService.comparatorsMap.greaterThanOrEqual,
				valueOne: 1
			};
			drilldownParams.itemType = 'Purchased';
			drilldownParams.sorters = [{ property: 'firstImpactedOrderDate', direction: 'ADC' }];

			return getReactDrilldownUrl('supply-chain/material-shortages/shortages-by-item/', drilldownParams);
		}

		function getReactShortageByOrderUrl(drilldownParams) {
			drilldownParams.requirementDate = {
				filterType: 'rangeFilter',
				comparator: leanFilterService.comparatorsMap.lessThan,
				valueOne: moment.utc().add(1, 'd').valueOf()
			};
			drilldownParams.itemType = 'Purchased';

			return getReactDrilldownUrl('supply-chain/material-shortages/shortages-by-order/', drilldownParams);
		}

		function currentShortages(row, col, rowIndex, params) {
			var cellValue = row[col.id];
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			if (cellValue || cellValue === 0) {
				cellValue = $filter('number')(cellValue);
			}
			var drilldownParams = {};
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			} else if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay']; 
			} else {
				drilldownParams = {
					'factory': leanFilterService.getSelectedIds('factory'),
					'buyerCode': row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']),
					'itemGroupNdx': leanFilterService.getSelectedIds('itemGroupNdx')
				};
			}
			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + '" title="Current Shortages: ' + cellValue + '">';
			if (isAggregated) {
				rawHtml += cellValue;
			} else {
				rawHtml += '<a href="' + getShortagesUrl(col, 'shortages', drilldownParams) + '" target="_blank">' + cellValue + '</a>';
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function currentShortagesBreakdown(row, col, rowIndex, params) {
			if (rowIndex === 0) {
				shortageCriticalityLevelService.setCriticalityBySites();
			}
			var breakdown = row.shortageCriticalityLevelCounts;
			var totalShortages = row[col.id];
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			if (totalShortages || totalShortages === 0) {
				totalShortages = $filter('number')(totalShortages);
			}
			var drilldownParams = {shortageCriticalityLevel: leanFilterService.getSelectedIds('shortageCriticalityLevelId')};
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			} else if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay']; 
			} else {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.buyerCode = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']);
				drilldownParams.itemGroupNdx = leanFilterService.getSelectedIds('itemGroupNdx');
			}
			var useMaxCount = leanFilterService.getSelectedIds('shortageCriticalityLevelId') 
					&& leanFilterService.getSelectedIds('shortageCriticalityLevelId').length === 1
					&& leanFilterService.getSelectedIds('shortageCriticalityLevelId')[0] !== leanFilterService.leanDnaAllSelected;
			var tooltip = breakdown && breakdown.length ? buildCriticalityLevelTooltipHtml(JSON.parse(breakdown)) : '';
			tooltip = tooltip.replace(/\"/g, '&quot;');
			var tooltipAttributes = breakdown && breakdown.length && row[col.id] ? ' tooltip-class="white-tooltip no-padding" uib-tooltip-html="\'' + tooltip + '\'" ' : '';
			var rawHtml = '<div class="cell-div with-trendline ' + getFooterClass(params, rowIndex) + '"' + tooltipAttributes + '>';
			var chartHtml = breakdown && breakdown.length ? buildBarChart(JSON.parse(breakdown), useMaxCount ? params.maxShortageCount : row[col.id]): '';
			var totalHtml = '<div class="deltaValue">';
			if (isAggregated) {
				totalHtml += totalShortages;
			} else {
				totalHtml += '<a href="' + getShortagesUrl(col, 'shortages', drilldownParams) + '" target="_blank">' + totalShortages + '</a>';
			}
			totalHtml += '</div>';
			rawHtml += chartHtml + totalHtml + '</div>';
			return rawHtml;
		}

		function burnOffTarget(row, col, rowIndex, params) {
			var rawValue = row[col.id];
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var cellValue = currencyFormatService.getWithParametersNegativeSign(row[col.id], 0, params.currencySymbol);
			var drilldownParams = {};
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			} else if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
			} else {
				drilldownParams = {
					'factory': leanFilterService.getSelectedIds('factory'),
					'itemGroupNdx': leanFilterService.getSelectedIds('itemGroupNdx')
				};
				drilldownParams.buyerCode = row['buyer'] === 'Total' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']);
			}
			var reportDrildownUrl = (typeof col.isBurnOff !== 'undefined' && col.isBurnOff ? burnOffDrilldownUrl : activeItemsUrl);
			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + '" title="' + cellValue + '">';
			if (isAggregated) {
				rawHtml += cellValue;
			} else {
				rawHtml += '<a href="' + getPfepAllItemsUrl(reportDrildownUrl, drilldownParams) + '" target="_blank">' + cellValue + '</a>';
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function getPfepAllItemsUrl(reportDrildownUrl, drilldownParams) {
			if (reportDrildownUrl === activeItemsUrl) {
				return getReactDrilldownUrl('supply-chain/inventory-opportunities/pfep-all-items', drilldownParams);
			}
			return addQueryParam(reportDrildownUrl, null, drilldownParams, false);
		}

		function getReactDrilldownUrl (url, params) {
			if(params.buyerCode) {
				var parsedDrilldownParams = _.cloneDeep(params);

				try {
					parsedDrilldownParams.buyerCode = decodeURIComponent(parsedDrilldownParams.buyerCode);
				} catch (e) {
					// skip decode error and leave buyerCode as it was
				} finally {
					return drilldownFunctionsService.getReportDrilldownUrl(url, null, parsedDrilldownParams, true);
				}
			}
			return drilldownFunctionsService.getReportDrilldownUrl(url, null, params, true);
		}

		function activeItems(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var cellValue = row[col.id];
			var formatedCellValue = integerFormatService.getWithParameters(cellValue < 0 ? cellValue * -1 : cellValue, 0);

			var arrowProperty = col.id + 'Dir';
			var rankProperty = col.rankProperty;

			var drilldownParams = {};
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			} else if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
			} else {
				drilldownParams = {
					'buyerCode': row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']),
					'factory': leanFilterService.getSelectedIds('factory'),
					'itemGroupNdx': leanFilterService.getSelectedIds('itemGroupNdx')
				};
			}

			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + ' ' + row[rankProperty] + '">';
			rawHtml += (!isAggregated ? '<a href="' + getPfepAllItemsUrl(activeItemsUrl, drilldownParams) + '" target="_blank">' : '');
			if (row[arrowProperty]) {
				rawHtml += '<div class="deltaArrowContainer"><i class="fa fa-arrow-' + row[arrowProperty] + ' small-arrow"></i></div>';
			}
			rawHtml += '<div class="deltaValue" title="' + formatedCellValue + '">';
			rawHtml += formatedCellValue + '</div>';
			rawHtml += (!isAggregated ? '</a>' : '');
			rawHtml += '</div>';
			return rawHtml;
		}

		function currencyWithPfepDrilldown(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var cellValue = row[col.id];
			var formatedCellValue = currencyFormatService.getWithParameters(cellValue < 0 ? cellValue * -1 : cellValue, 0, params.currencySymbol);

			var arrowProperty = col.id + 'Dir';
			var rankProperty = col.rankProperty;

			var drilldownParams = {};
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			} else if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
			} else {
				drilldownParams = {
					'buyerCode': row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']),
					'factory': leanFilterService.getSelectedIds('factory'),
					'itemGroupNdx': leanFilterService.getSelectedIds('itemGroupNdx')
				};
			}

			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + ' ' + row[rankProperty] + '">';
			rawHtml += (!isAggregated ? '<a href="' + getPfepAllItemsUrl(activeItemsUrl, drilldownParams) + '" target="_blank">' : '');
			if (row[arrowProperty]) {
				rawHtml += '<div class="deltaArrowContainer"><i class="fa fa-arrow-' + row[arrowProperty] + ' small-arrow"></i></div>';
			}
			rawHtml += '<div class="deltaValue" title="' + formatedCellValue + '">';
			rawHtml += formatedCellValue + '</div>';
			rawHtml += (!isAggregated ? '</a>' : '');
			rawHtml += '</div>';
			return rawHtml;
		}

		function site(row, col, rowIndex, params) {
			var cellValue = row[col.id];
			var drilldownParams = {
				dashboardType: 'Buyer Performance',
				shortageCriticalityLevel: leanFilterService.getSelectedIds('shortageCriticalityLevelId')
			};
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			}

			var rawHtml = '<div class="cell-div ' + getFooterClass(params, rowIndex) + '" title="' + cellValue + '">';
			rawHtml += '<a href="' + addQueryParam(buyerPerfDrilldown, null, drilldownParams, false) + '" target="_blank">' + cellValue + '</a>';
			rawHtml += '</div>';
			return rawHtml;
		}

		function itemGroup(row, col, rowIndex, params) {
			var cellValue = row[col.id];
			if (cellValue === 'UndefinedItemGroup') {
				cellValue = 'No Item Group';
			}
			var drilldownParams = {
				dashboardType: 'Buyer Performance'
			};
			if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
				drilldownParams.shortageCriticalityLevel = leanFilterService.getSelectedIds('shortageCriticalityLevelId');
			}

			var rawHtml = '<div class="cell-div ' + getFooterClass(params, rowIndex) + '" title="' + cellValue + '">';
			rawHtml += '<a href="' + addQueryParam(buyerPerfDrilldown, null, drilldownParams, false) + '" target="_blank">' + cellValue + '</a>';
			rawHtml += '</div>';
			return rawHtml;
		}

		function openInventoryActions(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var openActions = row[col.id];
			var totalActions = row['totalActions'];
			var openUrl = null;
			var drilldownParams = {};
			if (totalActions > 0) {
				if (params.viewType === 'site') {
					drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
				} else if (params.viewType === 'itemGroup') {
					drilldownParams.factory = leanFilterService.getSelectedIds('factory');
					drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
				} else {
					drilldownParams = {
						'factory': leanFilterService.getSelectedIds('factory'),
						'itemGroupNdx': leanFilterService.getSelectedIds('itemGroupNdx')
					};
					drilldownParams.buyerCode = row['buyer'] === 'Total' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']);
				}
				openUrl = addQueryParam(openDrilldownUrl, null, drilldownParams, false);
			}
			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + '" title="' + openActions + ' Open">';

			if (totalActions > 0 && openActions > 0 && !isAggregated) {
				rawHtml += '<a href="' + openUrl + '" target="_blank">' + openActions + '</a>';
			} else {
				rawHtml += 0;
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function fixedOrExpiredInventoryActions(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var isFixedType = col.id === 'fixedActions';
			var fixedOrExpiredActions = row[col.id];
			var totalActions = row['totalActions'];
			var fixedOrExpiredUrl = fixedOrExpiredDrilldownUrl + (isFixedType ? 'isFixed' : 'isExpired');
			var label = isFixedType ? 'Fixed' : 'Expired';
			var sort = isFixedType ? 'actualSavings' : 'expiredSavings';
			var currentTime = new Date();
			currentTime.setDate(currentTime.getDate() - 14); // two weeks ago
			var drilldownParams = {
				completedDateValueOne: currentTime.getTime(),
				completedDateComparator: 'gte',
				sort: sort,
				sortDesc: 1
			};
			if (totalActions > 0) {
				if (params.viewType === 'site') {
					drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
				} else if (params.viewType === 'itemGroup') {
					drilldownParams.factory = leanFilterService.getSelectedIds('factory');
					drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
				} else {
					drilldownParams.factory = leanFilterService.getSelectedIds('factory');
					drilldownParams.itemGroupNdx = leanFilterService.getSelectedIds('itemGroupNdx');
					drilldownParams.buyerCode = row['buyer'] === 'Total' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']);
				}
				fixedOrExpiredUrl = addQueryParam(fixedOrExpiredUrl, null, drilldownParams, false);
			}

			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + '" title="' + fixedOrExpiredActions + '  ' + label + ' (2 wks)">';
			if (totalActions > 0 && fixedOrExpiredActions > 0 && !isAggregated) {
				rawHtml += '<a href="' + fixedOrExpiredUrl + '" target="_blank">' + fixedOrExpiredActions + '</a>';
			} else {
				rawHtml += 0;
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function onHandInventoryDelta(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var cellValue = row[col.id];
			var formatedCellValue = currencyFormatService.getWithParameters(cellValue < 0 ? cellValue * -1 : cellValue, 0, params.currencySymbol);
			formatedCellValue = numberFormatService.getWithParameters(cellValue < 0 ? cellValue * -1 : cellValue, 0) !== '0' ? formatedCellValue : '';

			var rankProperty = col.rankProperty;
			var arrowProperty = col.id + 'Dir';
			var drilldownParams = { sort: 'weeklyInventoryDelta', sortDesc: 1 };
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			} else if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
			} else {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = leanFilterService.getSelectedIds('itemGroupNdx');
				drilldownParams.buyerCode = row['buyer'] === 'Total' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']);
			}

			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + ' ' + row[rankProperty] + '">';
			if (!isAggregated) {
				var url = getReactDrilldownUrl('supply-chain/inventory-opportunities/weekly-inventory-change', drilldownParams);
				rawHtml += '<a href="' + url + '" target="_blank">';
			}
			if (row[arrowProperty]) {
				rawHtml += '<div class="deltaArrowContainer"><i class="fa fa-arrow-' + row[arrowProperty] + ' small-arrow"></i></div>';
			}
			rawHtml += '<div class="deltaValue" title="' + formatedCellValue + '">' + formatedCellValue + '</div>';
			if (!isAggregated) {
				rawHtml += '</a>';
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function excessInventoryDelta(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var cellValue = row[col.id];
			var formatedCellValue = currencyFormatService.getWithParameters(cellValue < 0 ? cellValue * -1 : cellValue, 0, params.currencySymbol);
			formatedCellValue = numberFormatService.getWithParameters(cellValue < 0 ? cellValue * -1 : cellValue, 0) !== '0' ? formatedCellValue : '';
			var rankProperty = col.rankProperty;
			var arrowProperty = col.id + 'Dir';
			var drilldownParams = {};
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			} else if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
			} else {
				drilldownParams = {
					'factory': leanFilterService.getSelectedIds('factory'),
					'itemGroupNdx': leanFilterService.getSelectedIds('itemGroupNdx')
				};
				drilldownParams.buyerCode = row['buyer'] === 'Total' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']);
			}

			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + ' ' + row[rankProperty] + '">';
			if (!isAggregated) {
				var url = getReactDrilldownUrl('supply-chain/inventory-opportunities/excess-and-obsolete-inventory', drilldownParams);
				rawHtml += '<a href="' + url + '" target="_blank">';
			}
			if (row[arrowProperty]) {
				rawHtml += '<div class="deltaArrowContainer"><i class="fa fa-arrow-' + row[arrowProperty] + ' small-arrow"></i></div>';
			}
			rawHtml += '<div class="deltaValue" title="' + formatedCellValue + '">' + formatedCellValue + '</div>';
			if (!isAggregated) {
				rawHtml += '</a>';
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function shortagesDelta(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var cellValue = row[col.id];
			var formatedCellValue = integerFormatService.getWithParameters(cellValue < 0 ? cellValue * -1 : cellValue, 0);
			formatedCellValue = formatedCellValue !== '0' ? formatedCellValue : '';

			var arrowProperty = col.id + 'Dir';
			var rankProperty = col.rankProperty;

			var drilldownParams = {};
			if (params.viewType === 'site') {
				drilldownParams.factory = row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
			} else if (params.viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay']; 
			} else {
				drilldownParams = {
					'buyerCode': row.identifier === 'TOTAL' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']),
					'factory': leanFilterService.getSelectedIds('factory'),
					'itemGroupNdx': leanFilterService.getSelectedIds('itemGroupNdx')
				};
			}

			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + ' ' + row[rankProperty] + '">';
			rawHtml += (!isAggregated ? '<a href="' + getShortagesUrl(col, 'wkDeltaShortages', drilldownParams) + '" target="_blank">' : '');

			if (row[arrowProperty]) {
				rawHtml += '<div class="deltaArrowContainer"><i class="fa fa-arrow-' + row[arrowProperty] + ' small-arrow"></i></div>';
			}
			rawHtml += '<div class="deltaValue" title="' + formatedCellValue + '">';
			rawHtml += formatedCellValue + '</div>';
			rawHtml += (!isAggregated ? '</a>' : '');
			rawHtml += '</div>';
			return rawHtml;
		}

		function daysSinceLastAccess(row, col, rowIndex, params) {
			var cellValue = row.daysSinceLastAccessFmt;
			var rawHtml = '<div class="cell-div ' + getFooterClass(params, rowIndex) + '">';
			rawHtml += cellValue + '</div>';
			return rawHtml;
		}

		function getLatePRCountDrilldownParams(row, viewType) {
			var drilldownParams = { 'maxDaysUntilPOFirm': -1 };
			var isTotalRow = row.isTotal;
			if (viewType === 'site') {
				var site = isTotalRow ? leanFilterService.getSelectedIds('factory') : row.leanDirFactoryNdxs;
				drilldownParams.factory = site;
			} else if (viewType === 'itemGroup') {
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = isTotalRow ? leanFilterService.getSelectedIds('itemGroupNdx') : row.identifierDisplay;
			} else {
				drilldownParams.buyerCode = isTotalRow ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row.buyer);
				drilldownParams.factory = leanFilterService.getSelectedIds('factory');
				drilldownParams.itemGroupNdx = leanFilterService.getSelectedIds('itemGroupNdx');
			}
			return drilldownParams;
		}

		function latePRCount(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var cellValue = row[col.id];
			var formattedCellValue = integerFormatService.getWithParameters(cellValue, 0);
			formattedCellValue = formattedCellValue === '0' ? '' : formattedCellValue;
			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + ' ' + (cellValue > 0 ? 'bad' : '') + '">';
			var linkHtml = '<a href="" ng-click="vm.openLatePrCountDrilldown('
				+ (params.viewType ? "'" + params.viewType + "'": null)
				+ ',' + row.isTotal
				+ ',' + (row.leanDirFactoryNdxs ? "'" + row.leanDirFactoryNdxs + "'" : null)
				+ ',' + (row.identifierDisplay ? "'" + row.identifierDisplay.replace(/'/g, "\\\'") + "'" : null)
				+ ',' + (row.buyer ? "'" + row.buyer.replace(/'/g, "\\\'") + "'" : null)
				+ ')" target="_blank">' + formattedCellValue + '</a>';
			rawHtml += isAggregated ? '' : linkHtml;
			rawHtml += '</div>';
			return rawHtml;
		}

		function excessToSell(row, col, rowIndex, params) {
			var isAggregated = (row['isAggregated'] !== undefined && row['isAggregated']);
			var cellValue = row[col.id];
			var formattedCellValue = currencyFormatService.getWithParameters(cellValue < 0 ? cellValue * -1 : cellValue, 0, params.currencySymbol);
			var drilldownParams = {};
			var drilldownUrl = '';
			var displayValue = false;
			if (params.viewType === 'site') {
				displayValue = row.identifier !== 'TOTAL' && ('' + row.leanDirFactoryNdxs).indexOf(',') < 0;
			} else {
				var sites = leanFilterService.getSelectedIds('factory');
				var totalSites = 0;
				if (sites && sites.length) {
					if (sites.length > 1 || sites[0] !== 'LDNA_A_S') {
						totalSites = sites.length;
					} else {
						var siteFilterObj = leanFilterService.getFilterById('factory');
						if (siteFilterObj && siteFilterObj.objectList && siteFilterObj.objectList.length) {
							totalSites = siteFilterObj.objectList.length;
						} else {
							totalSites = 1;
						}
					} 
				} else {
					// This means no site filter, which is defaulted to the site you are logged into
					totalSites = 1;
				}
				displayValue = !params.siteList || (params.siteList.length === 1 && totalSites === 1);
			}
			if (displayValue && (row['hasLoggedInSite'] 
				|| (params.siteList && params.siteList.length === 1 && params.siteList[0] == globalConfig.factory.id))) {
				var drilldownparams = {};
				if (params.viewType === 'buyer') {
					drilldownParams.buyerCode = row['buyer'] === 'Total' ? leanFilterService.getSelectedIds('buyerCode') : encodeURIComponent(row['buyer']);
					drilldownParams.itemGroupNdx = leanFilterService.getSelectedIds('itemGroupNdx');
				} else if (params.viewType === 'itemGroup') {
					drilldownParams.itemGroupNdx = row['identifier'] === 'TOTAL' ? leanFilterService.getSelectedIds('itemGroupNdx') : row['identifierDisplay'];
				}
				drilldownUrl = addQueryParam(excessToSellDrilldown, null, drilldownParams, false);
			}
			var rawHtml = '<div class="cell-div shift-right ' + getFooterClass(params, rowIndex) + (!displayValue ? ' grayCell' : '') + '">';
			if (drilldownUrl) {
				rawHtml += (!isAggregated ? '<a href="' + drilldownUrl + '" target="_blank">' + formattedCellValue + '</a>' : formattedCellValue);
			} else if (displayValue) {
				rawHtml += formattedCellValue;
			} else {
				rawHtml += '<span class="hidden-text" title="Excess to sell not available when combining multiple sites">N/A</span>';
			}
			rawHtml += '</div>';
			return rawHtml;
		}

		function setCriticalityLevelColorsBasedOnRank(keysList) {
			var groupedLevels = _.chain(shortageCriticalityLevelService.getSelectedSitesCriticalities()).groupBy('label').map(function(criticality) {
				return {
					'label': criticality[0].label,
					'rank': _.maxBy(criticality, 'rank')['rank']
				};
			}).value();
			var criticalityLvlColors = {};
			_.orderBy(groupedLevels, ['rank']).map(function (group, index) {
				criticalityLvlColors[group.label] = _.indexOf(keysList, group.label) >= 0 && (index + 1) <= 4? 'rank-' + (index + 1) :  'rank-5';
			});
			criticalityLvlColors.None = 'rank-9999';
			criticalityLvlColors.Inactive = 'rank-inactive';
			return criticalityLvlColors;
		}

		function buildOrderedLevelList(breakdown) {
			var RANK_FOR_NONE = shortageCriticalityLevelService.rankForNone;
			var RANK_FOR_INACTIVE = shortageCriticalityLevelService.rankForInactive;
			var keysList = Object.keys(breakdown);
			var colors = setCriticalityLevelColorsBasedOnRank(keysList);
			var groupedLevels = _.chain(shortageCriticalityLevelService.getSelectedSitesCriticalities()).groupBy('label').map(function(criticality) {
				return {
					'label': criticality[0].label,
					'rank': _.maxBy(criticality, 'rank')['rank'],
					'active': _.maxBy(criticality, 'active')['active']
				};
			}).value();
			var orderedLevelList = keysList.map(function(level) {
				var matchingLevel = _.find(groupedLevels, {label: level});
				return {
					label: level === 'None' ? $translate.instant('Non Critical') : matchingLevel ? level : level + ' (inactive)',
					rank: level === 'None' ? RANK_FOR_NONE : matchingLevel ? matchingLevel.rank : RANK_FOR_INACTIVE,
					color: level === 'None' ? colors.None : matchingLevel ? colors[level] : colors.Inactive,
					count: breakdown[level],
					active: matchingLevel || level === 'None' ? true : false
				};
			}).sort(function(a, b) {
				return a.rank > b.rank ? 1 : -1;
			});

			return orderedLevelList;
		}
		
		function buildCriticalityLevelTooltipHtml(criticalityCounts) {
			var orderedLevelList = buildOrderedLevelList(criticalityCounts);
			var html = '<div class="myTooltip performance-tooltip">' +
				'<div class="tooltipBody">' +
				'<table border="1px solid">';
			orderedLevelList.forEach(function(level) {
				var additionalClass = level.active ? '' : 'label-inactive';
				if (level.count > 0) {
					html += '<tr>' + '<td><i class="fa fa-fw fa-circle ' + level.color + '"></i></td>' 
						+ '<td><span class="' + additionalClass + '">' + level.label.replace(/[^a-zA-Z0-9 #^@!.,?;:]/g, function(value) {
						return '&amp;#' + value.charCodeAt(0) + ';';
					}) + '</span></td>'
						+ '<td><span>' + level.count + '</span></td></tr>';
				}
			});
			html += '</table></div></div>';
			return html;
		}

		function countSummaryTooltip(countSummary) {
			var tooltip = '<div class="myTooltip performance-tooltip">' +
				'<div class="tooltipBody">' +
				'<table border="1px solid">';
			Object.entries(countSummary).forEach(function(obj) {
				var site = obj[0];
				var count = obj[1] || 0;
				tooltip += '<tr>' + '<td><span>' + site + '</span></td>'
				+ '<td><span>' + count + '</span></td></tr>';
			});
			tooltip += '</table></div></div>';
			return tooltip.replace(/\"/g, '&quot;');
		}

		function buildBarChart(breakdown, denominator) {
			var orderedLevelList = buildOrderedLevelList(breakdown);
			var html = '<div class="stacked-bar-chart">';
			var runningTotal = 0, maxIndex = 0, maxWidth = 0, currentIndex = 0;
			orderedLevelList.forEach(function(level) {
				var barWidth = Math.min(Math.ceil(level.count / denominator * 85), 85);
				runningTotal += barWidth;
				level.barWidth = barWidth;
				if (barWidth > maxWidth) {
					maxIndex = currentIndex;
					maxWidth = barWidth;
				}
				currentIndex++;
			});
			// Since using ceil, we may end up over 85px
			if (runningTotal > 85) {
				// Decrease largest bar by leftover
				orderedLevelList[maxIndex].barWidth -= (runningTotal - 85);
			}
			orderedLevelList.forEach(function(level) {
				html += '<div class="individual-bar ' + level.color + '"'
						+ ' style="width: ' + level.barWidth + 'px;"></div>';
			});
			html += '</div>';
			return html;
		}

		function getFilterTooltip() {
			return '<div class="myTooltip filter-tooltip">'
				+ '<div class="tooltipHeader">This filter only applies</div>'
				+ '<div class="tooltipHeader">to these columns:</div>'
				+ '<div class="tooltipBody">'
				+ '<ul><li>Current Shortages</li></ul></div></div>';
		}
	}

	function calculateDeltaValues(row) {
		var deltaColumns = ['DeltaExcessInv', 'DeltaInvOnHand', 'DeltaShortages', 'DeltaShortagesByOrderLines'];
		_.forEach(deltaColumns, function(col) {
			if (row['wk' + col] > 0) {
				row['wk' + col + 'Dir'] = 'up';
			} else if (row['wk' + col] < 0) {
				row['wk' + col + 'Dir'] = 'down';
			}

			if (row['ninetyDay' + col] > 0) {
				row['ninetyDay' + col + 'Dir'] = 'up';
			} else if (row['ninetyDay' + col] < 0) {
				row['ninetyDay' + col + 'Dir'] = 'down';
			}
		});
		
	}

	function aggregateDataForBuyerWithNoItem(aggregatedBuyersData, row) {
		if (aggregatedBuyersData === undefined) {
			aggregatedBuyersData = jQuery.extend({}, row);
			aggregatedBuyersData['buyerCount'] = 1;
			aggregatedBuyersData['aggregatedBuyers'] = row['buyer'];
			aggregatedBuyersData['shortageCriticalityCounts'] = row['shortageCriticalityCounts'] || {};
			aggregatedBuyersData['buyerMappingIssue'] = null;
			aggregatedBuyersData['buyerMappingIssueSummary'] = null;
		} else {
			aggregatedBuyersData['buyerCount'] += 1;
			aggregatedBuyersData['aggregatedBuyers'] +=  ', ' + row['buyer'];
			aggregatedBuyersData['invOnHand'] +=  row['invOnHand'];
			aggregatedBuyersData['invOnOrder'] +=  row['invOnOrder'];
			aggregatedBuyersData['numItems'] +=  row['numItems'];
			aggregatedBuyersData['shortages'] +=  row['shortages'];
			aggregatedBuyersData['excessInv'] +=  row['excessInv'];
			aggregatedBuyersData['earlyDeliveries'] +=  row['earlyDeliveries'];
			aggregatedBuyersData['obsoleteOnOrder'] +=  row['obsoleteOnOrder'];
			aggregatedBuyersData['tgtInv'] +=  row['tgtInv'];
			aggregatedBuyersData['potentialSavings'] +=  row['potentialSavings'];
			aggregatedBuyersData['latePRCount'] +=  row['latePRCount'];
			aggregatedBuyersData['wkDeltaExcessInv'] +=  row['wkDeltaExcessInv'];
			aggregatedBuyersData['wkDeltaInvOnHand'] +=  row['wkDeltaInvOnHand'];
			aggregatedBuyersData['wkDeltaLatePr'] +=  row['wkDeltaLatePr'];
			aggregatedBuyersData['wkDeltaShortages'] +=  row['wkDeltaShortages'];
			aggregatedBuyersData['ninetyDayDeltaExcessInv'] +=  row['ninetyDayDeltaExcessInv'];
			aggregatedBuyersData['ninetyDayDeltaInvOnHand'] +=  row['ninetyDayDeltaInvOnHand'];
			aggregatedBuyersData['ninetyDayDeltaShortages'] +=  row['ninetyDayDeltaShortages'];

			for (var key in row.shortageCriticalityCounts) {
				if (!aggregatedBuyersData.shortageCriticalityCounts[key]) {
					aggregatedBuyersData.shortageCriticalityCounts[key] = 0;
				}
				aggregatedBuyersData.shortageCriticalityCounts[key] += row.shortageCriticalityCounts[key];
				aggregatedBuyersData['currentShortages'] += row.shortageCriticalityCounts[key];
			}
		}
		return aggregatedBuyersData;
	}

})();
